import { useReadActiveEvent } from "@clockwise/web-commons/src/util/ActiveEventContext";
import classNames from "classnames";
import React from "react";
import { useReadActiveEventDiff } from "../../chat-plus-calendar/util/ActiveDiffContext";
import ErrorBoundary from "../../error-boundary/ErrorBoundary";
import { EventCardWrapper } from "../../event-card/EventCardWrapper";
import { EventCardOverlay } from "../../event-card/atoms/EventCardOverlay";
import { AIChatBox } from "./AIChatBox";
import { AIChatFeed } from "./AIChatFeed";
import { AIChatToolbar } from "./components/AIChatToolbar";
import { DiffEventCardExpanded } from "./components/diffs/diff-event-card-expanded";
import { useAIMessageContext } from "./hooks/AIMessageContext";
import { DefaultExpandedTradeoffProvider } from "./hooks/ExpandedTradeoffContext";
import { SuggestedPromptProvider } from "./hooks/SuggestedPromptContext";

export const AIChatLayout = () => {
  const { messages } = useAIMessageContext();

  const activeEvent = useReadActiveEvent();
  const activeDiff = useReadActiveEventDiff();

  const showOverlay = activeEvent || activeDiff?.id;

  const isEmptyState = messages.length === 0;
  return (
    <DefaultExpandedTradeoffProvider initValue={null}>
      <SuggestedPromptProvider initValue={null}>
        <div className="cw-relative cw-h-full cw-w-full cw-bg-neutral">
          {showOverlay && <EventCardOverlay />}
          {activeEvent && <EventCardWrapper activeEvent={activeEvent} />}
          {activeDiff?.id && <DiffEventCardExpanded id={activeDiff.id} />}
          <div className="cw-absolute cw-top-0 cw-right-0 cw-left-0 cw-z-[1] cw-h-16">
            <AIChatToolbar />
          </div>
          <div className="cw-w-full cw-body-base cw-flex-col cw-overflow-y-scroll cw-h-full cw-relative cw-pt-16">
            <div className="cw-w-full cw-min-h-full cw-flex-1 cw-flex cw-flex-col cw-align-center cw-pt-8">
              <div
                className={classNames(
                  "cw-flex-1 cw-flex cw-flex-col cw-pb-2 cw-px-5 cw-w-full cw-h-full cw-z-[0] cw-overflow-x-hidden",
                  { "cw-justify-end": !isEmptyState, "cw-justify-around": isEmptyState },
                )}
              >
                <ErrorBoundary>
                  <AIChatFeed />
                </ErrorBoundary>
              </div>
              <AIChatBox />
            </div>
          </div>
        </div>
      </SuggestedPromptProvider>
    </DefaultExpandedTradeoffProvider>
  );
};
